import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Create or Join',
    description:
      'Start a new game room or hop into one with a simple invite link. Gather your crew and get ready.',
    emoji: '🚀',
    className: 'step-1',
  },
  {
    number: '02',
    title: 'Get Your Word',
    description:
      'The drawer receives a secret word from the chosen category. Only you can see it, time to get creative!',
    emoji: '🤫',
    className: 'step-2',
  },
  {
    number: '03',
    title: 'Draw & Guess',
    description:
      'Sketch your masterpiece while others race to type the answer. The faster they guess, the more points everyone earns.',
    emoji: '✏️',
    className: 'step-3',
  },
  {
    number: '04',
    title: 'Celebrate & Repeat',
    description:
      'Cheer the winners, laugh at the drawings, and jump into the next round. Every game is a new chance to shine!',
    emoji: '🎉',
    className: 'step-4',
  },
];

function HowItWorks() {
  return (
    <section className="how" id="how">
      <div className="wrap">
        <div className="section-head">
          <div className="section-pill">
            <span className="section-pill-dot"></span> How It Works
          </div>
          <h2 className="section-h2">Ready to play in seconds</h2>
          <p className="section-p">
            No complicated setup. Jump right in with four simple steps.
          </p>
        </div>

        <div className="steps">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`step ${step.className} reveal ${index > 0 ? `reveal-d${index}` : ''}`}
            >
              <div className="step-badge">{step.number}</div>
              <div className="step-body">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              <div className="step-art">{step.emoji}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;